import { Player } from '@yleisradio/areena-types';
import { useCookieConsent } from 'contexts/CookieConsentContext';
import { useEffect, useRef } from 'react';

function isAutoplayEnabled(): boolean {
  if (typeof window !== 'undefined') {
    const { location } = window;
    const isAutoplayParameterSet = /[?#&]autoplay=true\b/.test(
      location.search + location.hash
    );
    const isSeekParameterSet = /[?&]seek=\d+\b/.test(location.search);
    return isAutoplayParameterSet || isSeekParameterSet;
  }
  return false;
}

export function useAutoplay({
  primaryPlayer,
  setActivePlayer,
}: {
  primaryPlayer: Player | undefined;
  setActivePlayer: (player: Player) => void;
}): void {
  const hasAutoplayBeenTriggeredRef = useRef<boolean>(false);
  const cookieConsent = useCookieConsent();
  const isCookieConsentGiven = !!cookieConsent;

  useEffect(() => {
    const hasAutoplayBeenTriggered = hasAutoplayBeenTriggeredRef.current;

    if (
      isAutoplayEnabled() &&
      primaryPlayer &&
      !hasAutoplayBeenTriggered &&
      isCookieConsentGiven
    ) {
      setActivePlayer(primaryPlayer);
      hasAutoplayBeenTriggeredRef.current = true;
    }
  }, [isCookieConsentGiven, primaryPlayer, setActivePlayer]);
}
